import { apiFetch } from "@/shared/api/http";

export interface AppLoginRequest {
  tenantSlug: string;
  email: string;
  senha: string;
}

export function loginApp(request: AppLoginRequest) {
  return apiFetch<{ nome: string; tenantId: string; userId: string }>("/api/app/auth/login", {
    method: "POST",
    body: JSON.stringify(request)
  });
}

export function logoutApp() {
  return apiFetch<void>("/api/app/auth/logout", { method: "POST" });
}
